import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetCertOrderDetailsQuery } from "../../../features/CallApi";
import LoadScreen from "../../UI/LoadScreen";
import { Container, Card, CardHeader, CardTitle, CardBody, CardFooter, Button, Row, Col, ButtonGroup } from "reactstrap";
import Axios from "axios";
import useToken from "../../useToken";
import { CertOrderStatus } from "./CertOrderStatus";
import { CertOrderCheckStatus } from "./CertOrderCheckStatus";

export const CerteficateDetails = () => {

    const { token, role } = useToken();
    const navigate = useNavigate();
    const [isDataLoading, setIsDataLoading] = useState(false);
    const { id } = useParams();
    const { isLoading, data: order, refetch, error, isFetching } = useGetCertOrderDetailsQuery({ id });
    const ReSend = () => {
        setIsDataLoading(true)
        Axios.get(`api/certificateorders/resend/${id}`, {
            headers: {
                Authorization: "Bearer " + token,
            }
        }).catch((e) => {
            setIsDataLoading(false)
            console.log(e)
            alert("Ошибка связи с почтовым сервером. Свяжитесь с администратором.");
        }).then(() => {
            setIsDataLoading(false)
            alert("Письмо с заказом успешно отправлено");
        })
    }
    const Refund = () => {
        if (window.confirm("Произвести возврат за покупку?")) {
            Axios.get(`api/certificateorders/refund/${id}`, {
                headers: {
                    Authorization: "Bearer " + token,
                }
            }).catch((e) => {
                setIsDataLoading(false)
                console.log(e)
                alert(e.data);
            }).then((respons) => {
                setIsDataLoading(false)
                alert(respons.data);
            })
        }
    }

    return (
        <Container>
            {error ? <div></div> :
                <div>
                    {isLoading || isDataLoading ? <LoadScreen />
                        :
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h4">
                                    Заказ # {order.id}
                                </CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md>
                                        <div className="mb-1">
                                            <label className="me-1">Ф.И.О.: </label>
                                            <strong>{order.client.lastName} {order.client.firstName} {order.client.patronymic}</strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">Номер сертификата: </label>
                                            <strong>{order.cardNumber == 0 ? "Не назначен" : order.cardNumber}</strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">Пин-код: </label>
                                            <strong>{order.pinCode}</strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">Номинал: </label>
                                            <strong>{order.amount}</strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">Дата выпуска:</label>
                                            <strong>{order.offered}</strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">Действет до:</label>
                                            <strong>{order.epxDate}</strong>
                                        </div>
                                    </Col>
                                    <Col md>
                                        <div className="mb-1">
                                            <label className="me-1">Номер телефона:  </label>
                                            <strong>{order.client.phone}</strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">E-Mail: </label>
                                            <strong>{order.client.email}</strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">Время заказа:</label>
                                            <strong>{order.orderDate}</strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">Номинал: </label>
                                            <strong>{order.amount}</strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">Статус: </label>

                                            <strong><CertOrderStatus status={order.status} /></strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">Статус чека:</label>
                                            <strong><CertOrderCheckStatus status={order.checkStatus} /></strong>
                                        </div>
                                        {order.receiptUrl &&
                                            <Button className="mt-3" size="sm" color="success" onClick={() => { window.open(order.receiptUrl, "_blank", "noreferrer") }}>Электронный чек</Button>
                                        }

                                    </Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col>
                                        <div className="mb-1">
                                            <label className="me-1">BankOrderId:</label>
                                            <strong>{order.bankOrderId} </strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">BankSessionId:</label>
                                            <strong>{order.bankSessionId}</strong>
                                        </div>
                                        <div className="mb-1">
                                            <label className="me-1">Номер банковской карты:</label>
                                            <strong>{order.clientCardNumber}</strong>
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardFooter>
                                {
                                    order.status === 7 ?
                                        <ButtonGroup>
                                            <Button onClick={() => navigate('../orders/certeficate')}>Назад</Button>
                                            <Button onClick={() => ReSend()} color="warning">Отправить повторно</Button>
                                            {role == "Admins" &&
                                                <Button onClick={() => Refund()} color="danger">Возврат покупки</Button>
                                            }
                                        </ButtonGroup>
                                        : <Button onClick={() => navigate('../orders/certeficate')}>Назад</Button>
                                }
                            </CardFooter>

                        </Card>}
                </div>}
        </Container>
    )
}